import { render, staticRenderFns } from "./AdminApiKeyManage.vue?vue&type=template&id=20944205&scoped=true"
import script from "./AdminApiKeyManage.vue?vue&type=script&lang=js"
export * from "./AdminApiKeyManage.vue?vue&type=script&lang=js"
import style0 from "./AdminApiKeyManage.vue?vue&type=style&index=0&id=20944205&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20944205",
  null
  
)

export default component.exports